// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lPbm","type":"styles_type__IPyY3","choices":"styles_choices__2FQsk"};